export default defineNuxtPlugin({
    name: 'privacy',
    async setup() {
        const $config = useRuntimeConfig();
        const {
            isGA4Enabled,
            isMetaFbPixelEnabled
        } = $config.public;

        if (!(isGA4Enabled || isMetaFbPixelEnabled)) return;

        const {
            consentCookie,
            applyConsent
        } = usePrivacySettingsUtils();

        // If the visitor has already made a choice, re-apply it to the
        // tracking scripts on every client load. New visitors are handled by
        // PrivacySettingsModal, which prompts and persists their choice.
        if (consentCookie.value) {
            applyConsent();
        }
    }
});
